/**
 * `createElement`, not JSX, because this file is `.ts` --
 * `src/app/routes/index.ts` uses the same construct for the same reason.
 *
 * Reached from a row in the register, never from the nav -- but still
 * wrapped in `OpsShell`: "no nav entry" and "no chrome" are different
 * things, and entitlement is asked once per screen, not once per screen
 * that happens to appear in the nav.
 */
import { createElement } from 'react';

import type { OpsRouteBundle } from '../routes/contract';
import { OpsShell } from '../shell/OpsShell';
import { TenantDetailScreen } from './TenantDetail';

export const bundle: OpsRouteBundle = {
  order: 15,
  routes: [
    {
      path: '/tenants/$tenantId',
      element: createElement(OpsShell, null, createElement(TenantDetailScreen)),
      kind: 'data',
    },
  ],
  nav: [],
};
